/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const { variant_metafields } = document.querySelector('[data-product-json]')
  ? JSON.parse(document.querySelector('[data-product-json]').innerHTML)
  : '';

const hideElement = (element) => element.classList.add('tw-hidden');
const showElement = (element) => element.classList.remove('tw-hidden');
const hideElements = (elements) => elements.forEach((element) => hideElement(element));

const showActiveVariantStockNotice = (event) => {
  const notices = document.querySelectorAll('.stock__notice');
  if (!notices) {
    return;
  }
  hideElements(notices);
  const notice = document.getElementById('stock_notice_variant_' + event.detail.variant.id);
  if (notice) {
    showElement(notice);
  }
};

const showActiveVariantFiles = (itemClass, elementPrefix, event) => {
  const filesContainer = document.getElementById(elementPrefix + '_container');
  if (!filesContainer) {
    return;
  }
  hideElement(filesContainer);
  hideElements(document.querySelectorAll(itemClass));
  const file = document.getElementById(elementPrefix + '_variant_' + event.detail.variant.id);
  if (file && file.innerHTML.trim() !== '') {
    showElement(filesContainer);
    showElement(file);
  }
};

const setQuantityDecreaseButtonDisabled = (disable) =>
  (document.getElementById('quantity-decrease-button').disabled = disable);

const updateProductQuantityInput = ({ detail: { variant, previousVariant } }) => {
  const quantityInput = document.getElementById('quantity-input-product');
  if (!quantityInput) {
    return;
  }
  const minimumOrderQuantity = variant_metafields[variant.id].minimum_order_quantity ?? 1;
  const previousMinimumOrderQuantity = variant_metafields[previousVariant.id].minimum_order_quantity ?? 1;
  quantityInput.min = minimumOrderQuantity;
  setQuantityDecreaseButtonDisabled(false);
  if (quantityInput.value == previousMinimumOrderQuantity || quantityInput.value < minimumOrderQuantity) {
    quantityInput.value = minimumOrderQuantity;
    setQuantityDecreaseButtonDisabled(true);
  }
  if (minimumOrderQuantity !== 1) {
    showElement(document.getElementById('quantity-minimum'));
    document.getElementById('quantity-minimum-text').textContent = minimumOrderQuantity;
    return;
  }
  hideElement(document.getElementById('quantity-minimum'));
};

document.addEventListener('variant:changed', function (event) {
  showActiveVariantStockNotice(event);
  showActiveVariantFiles('.product__label', 'product_label', event);
  showActiveVariantFiles('.product__safety_sheet', 'product_safety_sheet', event);
  showActiveVariantFiles('.product__file', 'product_file', event);
  updateProductQuantityInput(event);
});
